<template>
    <div v-if="order">
        <landing-page-navbar></landing-page-navbar>

        <div class="booking-view">
            <div class="content-container">
                <div class="content h-auto">

                    <div class="container">
                        <div class="title"><h1>Select Your Device Faults</h1></div>
                        <!-- Booking Overview -->
                        <div v-if="displayOverview" class="card">
                            <div class="card-header">
                                <h4>Booking Overview</h4>
                                <router-link class="cursor-pointer text-sm text-underline" to="/manage/booking" v-if="canManageBooking">Amend details</router-link>
                            </div>
                            <div class="card-body pb-0 d-flex flex-row">
                                <dl class="flex-grow-1">
                                    <dt>Repair location</dt>
                                    <dd>{{ order.details.address_1 }}</dd>
                                    <dd v-if="order.details.address_2">{{ order.details.address_2 }}</dd>
                                    <dd>{{ order.details.town }}</dd>
                                    <dd class="text-uppercase">{{ order.details.postcode }}</dd>
                                </dl>
                                <dl class="flex-grow-1" v-if="repairDate">
                                    <dt>Repair date</dt>
                                    <dd>{{ repairDate }}</dd>
                                </dl>
                            </div>
                        </div>

                        <template v-if="canConfirmBooking">
                            <div class="card">
                                <div class="card-header">
                                    <h4>{{ orderDevices.length > 1 ? 'Devices' : 'Device' }} to be repaired</h4>
                                </div>
                                <div class="card-body pb-3">
                                    <div class="basket-item" v-for="device in orderDevices" :key="device.id">
                                        <div class="media border-bottom pb-2 mb-2" v-if="device.model_version">
                                            <div class="media-left">
                                                <img :src="device.model_version.image.path" alt="Device Image" class="img-2x" />
                                            </div>
                                            <div class="media-body">
                                                <div class="align-items-center w-100">
                                                    <h5>{{ device.model_version.title }} {{device.model_version.colour.title}}</h5>
                                                </div>
                                                <div>
                                                    <p class="text-sm text-muted mt-1 mb-0">
                                                        If the above is incorrect please call our customer service team
                                                        on <strong>{{ carrierDetails.phone }}</strong> to make changes.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <confirm-device-problems-list
                                            class="mt-3"
                                            :device="device"
                                            :order-ref="order.details.uuid"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div v-else class="alert alert-info">
                            <i class="fa fa-info-circle"/>
                            <div class="alert-content">
                                Our technician will visit on {{ repairDate }} with everything they need to complete
                                the repair. If you have any queries please call our customer service team
                                on <strong>{{ carrierDetails.phone }}</strong> who would be more than happy to help.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import moment from "moment";
import ConfirmDeviceProblemsList from "../../components/manageBooking/ConfirmDeviceProblemsList";

export default {
    components: {ConfirmDeviceProblemsList},

    data() {
        return {
            displayOverview: false, // disable overview without deleting code, in case we want to have it display programmatically in the future
        }
    },

    computed: {
        ...mapGetters([
            "carrier",
            "carrierDetails",
            "order",
            "orderDevices",
            "currencySymbol"
        ]),

        // Can this booking be amended by the customer?
        canManageBooking() {
            const repairDate = moment(this.order.booking.booking_date);
            const now = moment();

            if (repairDate.isSameOrBefore(now)) {
                return false;
            }

            // Order is either not complete, or canceled.
            return this.order.details.order_status === "success";
        },

        // Can this booking be confirmed by the customer?
        // Is now after 5pm the day before the booking.
        canConfirmBooking() {
            const cutOffDate = moment(this.order.booking.booking_date, 'YYYY-MM-DD')
                .set('hour', 17)
                .set('minute', 0)
                .subtract(1, 'day');

            return moment().isSameOrBefore(cutOffDate, 'hour');
        },

        repairDate() {
            return this.order
                ? moment(this.order.booking.booking_date).format('ddd Do MMM')
                : null;
        },
    }
}
</script>

<style>
.card-header {
    background-color: #dbdbdb;
}
</style>